import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import { SplitButton } from "primereact/splitbutton";
//components
import Modal from "../../../components/modal/Modal";
import { useAppContext } from "../../../context/AppContext";

import { AccountFormToPay } from "./AccountFormToPay";
import { AccountReceiptReversalToPay } from "./AccountReceiptReversalToPay";
import { AccountReversedInstallmentsToPay } from "./AccountReversedInstallmentsToPay";
import { useFinancialContext } from "../../../context/FinancialContext";
import { AccountCenterCost } from "./AccountCenterCost";

export const AccountHeaderToPay = ({ updatedTable }) => {
  const navigate = useNavigate();
  const { permissions } = useAppContext();
  const { selectedCustomers, setSelectedCustomers } = useFinancialContext();

  const [receivables, setReceivables] = useState();
  const [modalReceipt, setModalReceipt] = useState(false);
  const [reversedInstallments, setReversedInstallments] = useState(false);
  const [reversedShipping, setReversedShipping] = useState(false);
  const [modalCenterCost, setModalCenterCost] = useState(false);
  const [selectedParcels, setSelectedParcels] = useState([]); // Novo estado para armazenar parcelas selecionadas

  const spreadsheet = [
    ...(permissions && permissions.includes("175")
      ? [
          {
            label: "Recebimento",
            icon: "fa fa-file-invoice-dollar",
            command: () => {
              const existReceived = selectedCustomers.filter(
                (item) => item.status === 1
              );
              if (
                existReceived.length > 0 &&
                existReceived.length === selectedCustomers.length
              ) {
                setModalReceipt(true);
              } else {
                toast.warning("Selecione apenas parcelas pagas");
              }
            },
          },
        ]
      : []),
    ...(permissions && permissions.includes("177")
      ? [
          //Fazer Estorno de Parcelas
          {
            label: "Parcela",
            icon: "fa fa-solid fa-copy",
            command: () => {
              setReversedInstallments(true);
            },
          },
        ]
      : []),
  ];

  const items = [
    {
      template: () => (
        <Link to={"/financial/accountToPay"} className="p-breadcrumb-link">
          Contas a Pagar
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  function closeModal() {
    setModalReceipt(false);
    setReversedInstallments(false);
    setSelectedCustomers([]);
    updatedTable();
  }

  function closeAddReceivables() {
    setReceivables(false);
  }

  function handleDownloadParcel() {
    const validade = selectedCustomers?.map((item) => {
      return item.status === 1;
    });

    if (selectedCustomers && !validade.includes(true)) {
      navigate("/financial/downloadParcelToPay");
    }
    if (validade.includes(true)) {
      toast.warning("Não é possível a baixa de parcelas pagas!");
    }
  }
  function handleCenterCost() {
    console.log("parcleas", selectedCustomers);
    setSelectedParcels(selectedCustomers); // Armazena as parcelas antes de abrir a modal
    setModalCenterCost(true);
  }
  return (
    <div className="row p-0">
      <div className="col-xl-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <div className="col-xl-8 text-end p-0">
        <div className="row justify-content-end pb-3">
          {permissions?.includes("176") && (
            <div className="col-xl-3 col-md-4">
              <SplitButton
                label="Estornar"
                disabled={selectedCustomers?.length === 0}
                icon="fa fa-undo"
                model={spreadsheet.filter(
                  (item) => item !== false && typeof item === "object"
                )}
                rounded
                severity="danger"
                className="w-100 pb-2"
              />
            </div>
          )}

          {permissions?.includes("174") && (
            <div className="col-xl-3 col-md-4 mb-2">
              <Button
                rounded
                disabled={selectedCustomers?.length === 0}
                label="Baixar Parcela"
                icon="fa fa-download"
                onClick={() => handleDownloadParcel()}
                className="p-inputtext-sm me-2 m-auto w-100"
              />
            </div>
          )}
          {permissions?.includes("172") && (
            <div className="col-xl-3 col-md-4 mb-2">
              <Button
                rounded
                severity="success"
                label="Lançamento"
                icon="fa fa-plus"
                onClick={() => setReceivables(true)}
                className="p-inputtext-sm me-2 m-auto w-100"
              />
            </div>
          )}
        </div>
      </div>

      <Modal
        visible={receivables}
        dynamicTitle={"Contas a Pagar"}
        onHide={closeAddReceivables}
        closable={true}
      >
        <AccountFormToPay closeModal={closeAddReceivables} />
      </Modal>

      <Modal
        visible={modalReceipt}
        dynamicTitle={"Confirmar estorno de recebimento"}
        onHide={() => setModalReceipt(false)}
        closable={true}
      >
        <AccountReceiptReversalToPay
          closeModal={closeModal}
          rowsSelected={selectedCustomers}
        />
      </Modal>

      <Modal
        visible={reversedInstallments}
        dynamicTitle={"Confirmar parcelas estornadas"}
        onHide={() => setReversedInstallments(false)}
        closable={true}
      >
        <AccountReversedInstallmentsToPay
          closeModal={closeModal}
          rowsSelected={selectedCustomers}
        />
      </Modal>
   
    </div>
  );
};
